import { type TranslationTree } from '@/i18n/types';

export const messages = {
  titleRequired: 'O título é obrigatório',
  titleShort: 'O título precisa de pelo menos 3 caracteres',
  titleLong: 'O título pode ter até 60 caracteres',
  bodyRequired: 'O texto é obrigatório',
  bodyShort: 'O texto precisa de pelo menos 10 caracteres',
  bodyLong: 'O texto pode ter até 240 caracteres',
  couponRequired: 'O cupom é obrigatório',
  couponLong: 'O cupom pode ter até 30 caracteres',
  couponTermsLong: 'As regras do cupom podem ter até 200 caracteres',
  actionKind: 'Escolha o tipo do botão',
  actionLabelShort: 'O texto do botão precisa de pelo menos 2 caracteres',
  actionLabelLong: 'O texto do botão pode ter até 30 caracteres',
  urlRequired: 'O link é obrigatório',
  urlInvalid: 'Digite um link válido, começando com https://',
  urlLong: 'O link pode ter até 500 caracteres',
  whatsappInvalid: 'Digite o WhatsApp com DDD',
  phoneInvalid: 'Digite o telefone com DDD',
  messageLong: 'A mensagem pode ter até 200 caracteres',
  actionsOrCoupon: 'Adicione um botão ou um cupom',
  actionsMax: 'A oferta pode ter até 2 botões',
  actionDuplicate: 'Esse botão já está na oferta',
  locationRequired: 'Adicione o endereço para o botão "Como chegar"',
  locationsMax: 'A oferta pode ter até 20 endereços',
  locationLabelLong: 'O nome do local pode ter até 60 caracteres',
  audienceLong: 'O público pode ter até 280 caracteres',
  dateInvalid: 'Data inválida',
  endBeforeStart: 'O fim precisa ser depois do início',
} satisfies TranslationTree;
